import { cnpj, cpf } from 'cpf-cnpj-validator';
import moment from 'moment';
import 'moment/locale/pt-br';

const global = {
	methods: {
		isEmptyObject(obj) {
			return Object.keys(obj).length === 0 && obj.constructor === Object;
		},
		passwordValid(password, options, confirmPassword = '') {
			let isUpperValid = false;
			let isLowerValid = false;
			let isLengthValid = false;
			let isSpecialValid = false;
			let passwordConfirmed = false;
			let isNumericValid = false;

			if (confirmPassword !== '') {
				if (password === confirmPassword) {
					passwordConfirmed = true;
				}
			}
			if (options.strLength) {
				if (password.length >= options.strLength.min) {
					isLengthValid = true;
				}
			}

			if (options.strUpper) {
				let qtUppercase = 0;
				password.split('').map((str) => {
					if (this.isUpperCase(str)) {
						qtUppercase += 1;
					}
					return true;
				});
				if (qtUppercase >= options.strUpper.min) {
					isUpperValid = true;
				}
			}
			if (options.srtNumber) {
				let qtNumeric = 0;
				password.split('').map((str) => {
					// eslint-disable-next-line no-restricted-globals
					if (!isNaN(str)) {
						// eslint-disable-next-line no-restricted-globals
						qtNumeric += 1;
					}
					return true;
				});
				if (qtNumeric >= options.srtNumber.min) {
					isNumericValid = true;
				}
			}

			if (options.specialChar) {
				let qtspecialChar = 0;
				password.split('').map((str) => {
					if (this.isSpecialChar(str)) {
						qtspecialChar += 1;
					}
					return true;
				});
				if (qtspecialChar >= options.specialChar.min) {
					isSpecialValid = true;
				}
			}

			if (options.strLower) {
				let qtLowerCase = 0;
				password.split('').map((str) => {
					if (this.isLowerCase(str)) {
						qtLowerCase += 1;
					}
					return true;
				});
				if (qtLowerCase >= options.strLower.min) {
					isLowerValid = true;
				}
			}
			return {
				isLengthValid,
				isUpperValid,
				isLowerValid,
				isSpecialValid,
				passwordConfirmed,
				isNumericValid,
			};
		},
		isSpecialChar(str) {
			const regex = /^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]$/;
			return regex.test(str);
		},
		notification(message, type) {
			this.$buefy.notification.open({
				message: message.toString(),
				type,
			});
		},
		maskCPF(mcpf) {
			// eslint-disable-next-line
			mcpf = mcpf.replace(/\D/g, '');
			// eslint-disable-next-line
			mcpf = mcpf.replace(/(\d{3})(\d)/, '$1.$2');
			// eslint-disable-next-line
			mcpf = mcpf.replace(/(\d{3})(\d)/, '$1.$2');
			// eslint-disable-next-line
			mcpf = mcpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
			return mcpf;
		},
		formataNumeroTelefone(str) {
			let result = '~';
			if (str === 'A') {
				return 'Atualmente';
			}
			// Se menor que 11 é um número de tel. fixo
			if (str && str.length < 11) {
				result = str.replace(/(\d{2})(\d{4})(\d{4})/g, '($1) $2-$3');
			} else if (str) {
				result = str.replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3');
			}
			return result;
		},
		isUpperCase(str) {
			return str === str.toUpperCase();
		},
		isLowerCase(str) {
			return str === str.toLowerCase();
		},
		transformMoneyToNumber(money) {
			if (money) {
				let numbermoney = money.toString();
				numbermoney = numbermoney.split('.');
				numbermoney = numbermoney[0] + numbermoney[1];
				numbermoney = parseInt(numbermoney, 36);
				return numbermoney;
			}
			return 0;
		},
		isset(strVariableName) {
			try {
				// eslint-disable-next-line no-eval
				eval(strVariableName);
			} catch (err) {
				if (err instanceof ReferenceError) {
					return false;
				}
			}

			return true;
		},
		transformToUsd(money) {
			if (money) {
				if (typeof money === 'string') {
					// eslint-disable-next-line no-param-reassign
					money = parseFloat(money);
				}
				return money.toLocaleString({
					style: 'currency',
					currency: 'USD',
				});
			}
			return 'R$ 0,00';
		},
		transformToBrl(money) {
			if (money) {
				if (typeof money === 'string') {
					// eslint-disable-next-line no-param-reassign
					money = parseFloat(money);
				}
				return money.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
					minimumFractionDigits: 2,
				});
			}
			return 'R$ 0,00';
		},
		transformToBrlNoSymbol(money) {
			if (money) {
				return parseFloat(money).toLocaleString('pt-br');
			}
			return '0,00';
		},
		searchWordInString(text, word) {
			if (word) {
				const result = text.toLowerCase().search(word.toLowerCase());
				return result;
			}
			return null;
		},
		getRandomInt(min, max) {
			// eslint-disable-next-line no-param-reassign
			min = Math.ceil(min);
			// eslint-disable-next-line no-param-reassign
			max = Math.floor(max);
			return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
		},
		formatCnpjCpf(num) {
			if (cnpj.isValid(num)) {
				return cnpj.format(num);
			}
			if (cpf.isValid(num)) {
				return cpf.format(num);
			}
			return 'Vazio';
		},
		returnElapsedTime(data) {
			if (data) {
				return moment(data).fromNow();
			}
			return '~';
		},
		searchForDuplicatesByIndex(indexAndData = {}, array = []) {
			if (array && indexAndData) {
				const searchIndexes = [];
				// eslint-disable-next-line no-plusplus
				for (let index = 0; index < array.length; index++) {
					const element = array[index];
					if (element[indexAndData.index] === indexAndData.data) {
						searchIndexes.push(index);
					}
				}
				return searchIndexes;
			}
			return -1;
		},
		dateTimeToBrasil(datetime = '00-00-00 00:00:00') {
			if (datetime) {
				const itemparsed = datetime.split(' ');
				let newDateParsed = itemparsed[0].split('-');
				newDateParsed = `${newDateParsed[2]}/${newDateParsed[1]}/${newDateParsed[0]} as ${itemparsed[1]}`;
				return newDateParsed;
			}
			return '~';
		},
		parseToInputDatetimeLocal(datetime = '00-00-00 00:00:00') {
			if (datetime) {
				const itemparsed = datetime.split(' ');
				let newDateParsed = itemparsed[0].split('-');
				newDateParsed = `${newDateParsed[0]}-${newDateParsed[1]}-${newDateParsed[2]}T${itemparsed[1]}`;
				return newDateParsed;
				/* return `${itemparsed[0]}T${itemparsed[1]}`; */
			}
			return '~';
		},
		dateTimeToBrasilWithTimezone(timestamp = null) {
			if (timestamp) {
				const itemparsed = timestamp.split(' ');
				let newDateParsed = itemparsed[0].split('-');
				// eslint-disable-next-line prefer-destructuring
				itemparsed[1] = itemparsed[1].split('-')[0];
				// eslint-disable-next-line prefer-destructuring
				itemparsed[1] = itemparsed[1].split('.')[0];

				newDateParsed = `${newDateParsed[2]}/${newDateParsed[1]}/${newDateParsed[0]} as ${itemparsed[1]}`;
				return newDateParsed;
			}
			return '~';
		},
		dateToBrasil(datetime = '00-00-00') {
			if (datetime) {
				let newDateParsed = datetime.split('-');
				newDateParsed = `${newDateParsed[2]}/${newDateParsed[1]}/${newDateParsed[0]}`;
				return newDateParsed;
			}
			return 'Vazio';
		},
		dateTimetoDate(datetime = '00-00-00 00:00:00') {
			if (datetime) {
				const itemparsed = datetime.split(' ');
				let newDateParsed = itemparsed[0].split('-');
				newDateParsed = `${newDateParsed[2]}/${newDateParsed[1]}/${newDateParsed[0]}`;
				return newDateParsed;
			}
			return 'Vazio';
		},
		dateTimetoDateNoLocale(datetime = '00-00-00 00:00:00') {
			if (datetime) {
				const itemparsed = datetime.split(' ');
				return itemparsed[0];
			}
			return '00-00-00 00:00:00';
		},
		dateTimetoTime(datetime = '00-00-00 00:00:00') {
			if (datetime) {
				let itemparsed = datetime.split(' ');
				// eslint-disable-next-line prefer-destructuring
				itemparsed = itemparsed[1];
				return itemparsed;
			}
			return 'Vazio';
		},
	},
};

export default global;
